module.exports = __webpack_public_path__ + "img/459.65d3e08a.png";